import { z } from 'zod';

import { isPasswordValid } from '@/features/auth/validation/password-validation';

export const passwordSchema = z
  .string({ error: 'required' })
  .min(1, 'required')
  .min(8, 'too_short')
  .max(100, 'too_long')
  .refine(isPasswordValid, { message: 'not_secure' });

export const loginPasswordSchema = z
  .string({ error: 'required' })
  .min(1, 'required');
